import Component from '../core/Component';
import $ from 'jquery';
import enquire from 'enquire.js';
import { queries } from '../core/config';
import { throttle } from 'lodash';

export default class Banner extends Component
{
    constructor($element)
    {
        super($element);
        this.gap = 120;
        this.$move = $element.find('.banner__link');

        setTimeout(() => {
            this.offset = this.$element.offset().top;
            this.max = $(document).height() - 1200;
        }, 600)
    }

    prepare ()
    {
        setTimeout(() => {
            enquire.register('screen and (min-width: 57.5em)', {
                match: () => {
                    this.attach();
                },
                unmatch: () => {
                    this.detach();
                }
            });
        }, 600)
    }

    STATE = false;
    STATEMAX = false;

    destroy () {
        this.detach();
    }

    attach () {
        $(window).on('scroll', throttle(::this.onScroll, 16));
        $(window).on('resize', throttle(::this.reset, 16));
    }

    detach () {
        $(window).off('scroll', throttle(::this.onScroll, 16));
        $(window).off('resize', throttle(::this.reset, 16));
    }

    reset () {
        this.offset = this.$element.offset().top;
        this.max = $(document).height() - 1200;
        this.unfix();
        var scrollTop = $(window).scrollTop();
        var position = this.offset - this.gap;
        if (scrollTop >= position && !this.STATE) {
            this.fix();
        }
    }

    onScroll(event) {
        var scrollTop = $(window).scrollTop();
        var position = this.offset - this.gap;
        if (scrollTop >= position && !this.STATE) {
            this.fix();
        } else if (scrollTop < position && this.STATE) {
            this.unfix();
        }

        if (scrollTop >= this.max && !this.STATEMAX) {
            this.STATEMAX = true;
            this.$move.addClass('hide');
        } else if (scrollTop < this.max && this.STATEMAX) {
            this.STATEMAX = false;
            this.$move.removeClass('hide');
        }
    }

    fix () {
        this.STATE = true;
        this.$move.css("top", this.gap);
        this.$move.css("width", this.$move.width());
        this.$move.css("left", this.$move.offset().left);
        this.$move.css("position", "fixed");
    }

    unfix () {
        this.STATE = false;
        this.$move.css("top", "");
        this.$move.css("left", "");
        this.$move.css("width", "");
        this.$move.css("position", "");
    }
}


// WEBPACK FOOTER //
// ./components/Banner.js